import { SelectOption } from '@globaleris/ui.library'
import {
  ProductTranslationModel,
  TranslationModelBase,
  ConceptTranslationModel
} from './translationsCard.model'
import { LanguageModel } from '../../../api/Argentia/model/contracts'

export const getUnusedTranslations = (
  productTranslations: ConceptTranslationModel[],
  languages: LanguageModel[],
  row?: any
): SelectOption[] => {
  // Take all the used translations from component Prop 'translations'
  const usedTranslations = productTranslations.map(t => {
    return {
      value: t.language,
      label: t.description
    }
  })

  // Filter unused languages from FetchLanguages
  const unusedLanguages = languages.filter(l => {
    return (
      !usedTranslations.some(t => {
        return t.value === l.id ? true : false
      }) || l.id === row?.language
    )
  })

  // Transform LanguageModel to SelectOption
  const unusedTranslations = unusedLanguages.map(l => {
    return {
      value: l.id,
      label: l.description
    }
  })

  return unusedTranslations
}

// export const getUnusedTranslations = <T extends TranslationModelBase>(
//   translations: T[],
//   languages: LanguageModel[],
//   row?: T
// ): SelectOption[] => {
//   const usedTranslations = translations.map(t => ({
//     value: t.language,
//     label: t.description
//   }))

//   const unusedLanguages = languages.filter(l => {
//     return (
//       !usedTranslations.some(t => {
//         return t.value === l.id ? true : false
//       }) || l.id === row?.language
//     )
//   })

//   return unusedLanguages.map(l => ({
//     value: l.id,
//     label: l.description
//   }))
// }
